import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Bell } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
    api.post("/notifications/read").catch(() => {});
  }, []);
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Notifications</h1>
      {items.length === 0 ? <div className="card-surface p-8 text-center text-content-muted">No notifications.</div> : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className="card-surface p-4 flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-ember-soft flex items-center justify-center shrink-0"><Bell className="w-4 h-4 text-ember" /></div>
              <div>
                <div className="text-sm font-medium">{n.title}</div>
                <div className="text-sm text-content-secondary">{n.body}</div>
                <div className="text-xs text-content-muted mt-1">{new Date(n.created_at).toLocaleString("en-IN")}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
